// Generated Master Table List
export enum Tables {
  A3_METADATA = "a3_metadata",
  A3_RATING_TIME_SERIES = "a3_rating_time_series",
  A5_BANK_POSITIONS = "a5_bank_positions",
  A5_DERIVATIVE_BARRIERS = "a5_derivative_barriers",
  A5_DERIVATIVE_UNDERLYINGS = "a5_derivative_underlyings",
  A5_EVENTS = "a5_events",
  A5_ISSUERS = "a5_issuers",
  A5_MASKING = "a5_masking",
  A5_PDF_EXPORTS = "a5_pdf_exports",
  A5_PORTFOLIOS = "a5_portfolios",
  A5_POSITIONS = "a5_positions",
  A5_STATIC_DATA = "a5_static_data",
  A5_TIME_SERIE_FILES = "a5_time_serie_files",
  A5_TIME_SERIES = "a5_time_series",
  A5_TRANSACTIONS = "a5_transactions",
  A6_BANK_POSITIONS = "a6_bank_positions",
  A6_ISSUERS = "a6_issuers",
  A6_MASKING = "a6_masking",
  A6_PDF_EXPORTS = "a6_pdf_exports",
  A6_PDF_EXTRACTIONS = "a6_pdf_extractions",
  A6_PDF_PAGE_SELECTION = "a6_pdf_page_selection",
  A6_PORTFOLIOS = "a6_portfolios",
  A6_POSITIONS = "a6_positions",
  A6_STATIC_DATA = "a6_static_data",
  A6_EVENTS = "a6_events",
  A6_TIME_SERIE_FILES = "a6_time_serie_files",
  A6_TIME_SERIES = "a6_time_series",
  A6_TRANSACTIONS = "a6_transactions",
  A7_COMPOSITIONS = "a7_compositions",
  A7_FIA_CALCULATION_JOBS = "a7_fia_calculation_jobs",
  A7_FIA_COMPOSITIONS = "a7_fia_compositions",
  A7_FIA_COMPOSITIONS_AUDIT = "a7_fia_compositions_audit",
  A7_FIA_FILES = "a7_fia_files",
  A7_FIA_INSTRUMENT_TS = "a7_fia_instrument_ts",
  A7_FIA_INSTRUMENT_TS_AUDIT = "a7_fia_instrument_ts_audit",
  A7_FIA_INSTRUMENTS = "a7_fia_instruments",
  A7_FIA_INSTRUMENTS_AUDIT = "a7_fia_instruments_audit",
  A7_FIA_ISSUER_TS = "a7_fia_issuer_ts",
  A7_FIA_ISSUER_TS_AUDIT = "a7_fia_issuer_ts_audit",
  A7_FIA_ISSUERS = "a7_fia_issuers",
  A7_FIA_ISSUERS_AUDIT = "a7_fia_issuers_audit",
  A7_FIA_TIME_SERIE_FILES = "a7_fia_time_serie_files",
  A7_FIA_TIME_SERIE_FILES_AUDIT = "a7_fia_time_serie_files_audit",
  A7_OPCVM_CALCULATION_JOBS = "a7_opcvm_calculation_jobs",
  A7_OPCVM_CLIENT_PORTFOLIOS = "a7_opcvm_client_portfolios",
  A7_OPCVM_CLIENT_PORTFOLIOS_AUDIT = "a7_opcvm_client_portfolios_audit",
  A7_OPCVM_COMPOSITIONS = "a7_opcvm_compositions",
  A7_OPCVM_COMPOSITIONS_AUDIT = "a7_opcvm_compositions_audit",
  A7_OPCVM_FILES = "a7_opcvm_files",
  A7_OPCVM_ISSUER_TS = "a7_opcvm_issuer_ts",
  A7_OPCVM_ISSUER_TS_AUDIT = "a7_opcvm_issuer_ts_audit",
  A7_OPCVM_ISSUERS = "a7_opcvm_issuers",
  A7_OPCVM_ISSUERS_AUDIT = "a7_opcvm_issuers_audit",
  A7_OPCVM_STRATEGIES = "a7_opcvm_strategies",
  A7_OPCVM_STRATEGIES_AUDIT = "a7_opcvm_strategies_audit",
  A7_OPCVM_TIME_SERIE_FILES = "a7_opcvm_time_serie_files",
  A7_OPCVM_TIME_SERIE_FILES_AUDIT = "a7_opcvm_time_serie_files_audit",
  A7_OPCVM_UNDERLYING_TS = "a7_opcvm_underlying_ts",
  A7_OPCVM_UNDERLYING_TS_AUDIT = "a7_opcvm_underlying_ts_audit",
  A7_OPCVM_UNDERLYINGS = "a7_opcvm_underlyings",
  A7_OPCVM_UNDERLYINGS_AUDIT = "a7_opcvm_underlyings_audit",
  A7_STRATEGIES = "a7_strategies",
  A8_COMPOSITIONS = "a8_compositions",
  A8_PORTFOLIOS = "a8_portfolios",
  A8_STATIC_DATA = "a8_static_data",
  A8_TEXT_CHUNKS = "a8_text_chunks",
  A8_TIME_SERIES = "a8_time_series",
  A8_TRANSACTIONS = "a8_transactions",
  A9_DOCUMENT_PAGE_EMBEDDINGS = "a9_document_page_embeddings",
  A9_ISSUERS = "a9_issuers",
  A9_PDF_EXPORTS = "a9_pdf_exports",
  A9_PDF_PAGE_SELECTION = "a9_pdf_page_selection",
  A9_PORTFOLIOS = "a9_portfolios",
  A9_STATIC_DATA = "a9_static_data",
  A9_TIME_SERIE_FILES = "a9_time_serie_files",
  A9_TIME_SERIES = "a9_time_series",
  A9_TRANSACTIONS = "a9_transactions",
  ACTIVE_ADMIN_COMMENTS = "active_admin_comments",
  ADMIN_USER_ACTIONS = "admin_user_actions",
  AGGREGATIONS = "aggregations",
  AHOY_EVENTS = "ahoy_events",
  AI_CONVERSATIONS = "ai_conversations",
  AI_FO_EXAMPLES = "ai_fo_examples",
  AI_KEYWORDS = "ai_keywords",
  AI_MESSAGES = "ai_messages",
  API_KEYS = "api_keys",
  AR_INTERNAL_METADATA = "ar_internal_metadata",
  AUDITS = "audits",
  AXES = "axes",
  B1_METADATA = "b1_metadata",
  C3_BANK_POSITIONS = "c3_bank_positions",
  C3_DEDICATED_FUNDS = "c3_dedicated_funds",
  C3_PORTFOLIOS = "c3_portfolios",
  C3_POSITIONS = "c3_positions",
  C3_STATIC_DATA = "c3_static_data",
  C3_TIME_SERIE_FILES = "c3_time_serie_files",
  C3_TIME_SERIES = "c3_time_series",
  C3_TRANSACTIONS = "c3_transactions",
  C5_BANK_POSITIONS = "c5_bank_positions",
  C5_ISSUERS = "c5_issuers",
  C5_PDF_EXPORTS = "c5_pdf_exports",
  C5_PDF_EXTRACTIONS = "c5_pdf_extractions",
  C5_PDF_PAGE_SELECTION = "c5_pdf_page_selection",
  C5_PORTFOLIOS = "c5_portfolios",
  C5_POSITIONS = "c5_positions",
  C5_STATIC_DATA = "c5_static_data",
  C5_EVENTS = "c5_events",
  C5_TIME_SERIE_FILES = "c5_time_serie_files",
  C5_TIME_SERIES = "c5_time_series",
  C5_TRANSACTIONS = "c5_transactions",
  C6_METADATA = "c6_metadata",
  C7_POSITIONS = "c7_positions",
  C8_STATIC_DATA = "c8_static_data",
  C8_TIME_SERIES = "c8_time_series",
  C8_TRANSACTIONS = "c8_transactions",
  CLIENT_PORTFOLIOS = "client_portfolios",
  COCKPITS = "cockpits",
  COMPANIES = "companies",
  COMPANIES_PROVIDER_CONFIGS = "companies_provider_configs",
  CONNECTOR_CONFIGS = "connector_configs",
  COMPANY_APPROVALS = "company_approvals",
  COMPO_DATES = "compo_dates",
  COUNTRIES = "countries",
  CUSTOMLISTS = "customlists",
  CUSTOMLISTS_ISSUERS = "customlists_issuers",
  CUSTOMLISTS_STRATEGIES = "customlists_strategies",
  D1_BANK_POSITIONS = "d1_bank_positions",
  D1_ISSUERS = "d1_issuers",
  D1_PDF_EXPORTS = "d1_pdf_exports",
  D1_PDF_EXTRACTIONS = "d1_pdf_extractions",
  D1_PDF_PAGE_SELECTION = "d1_pdf_page_selection",
  D1_PORTFOLIOS = "d1_portfolios",
  D1_POSITIONS = "d1_positions",
  D1_STATIC_DATA = "d1_static_data",
  D1_EVENTS = "d1_events",
  D1_TIME_SERIE_FILES = "d1_time_serie_files",
  D1_TIME_SERIES = "d1_time_series",
  D1_TRANSACTIONS = "d1_transactions",
  DASHBOARDS = "dashboards",
  DELAYED_JOBS = "delayed_jobs",
  DEMO_COMPOSITIONS = "demo_compositions",
  DEMO_PORTFOLIOS = "demo_portfolios",
  DEMO_STATIC_DATA = "demo_static_data",
  DEMO_TIME_SERIES = "demo_time_series",
  DEMO_TRANSACTIONS = "demo_transactions",
  DISCLAIMERS = "disclaimers",
  DYNAMIC_SELECTIONS = "dynamic_selections",
  E2_DYNAMIC_DATA = "e2_dynamic_data",
  E2_EXPORTS = "e2_exports",
  E2_POSITIONS = "e2_positions",
  E3_ISSUERS = "e3_issuers",
  E3_PDF_EXPORTS = "e3_pdf_exports",
  E3_PDF_EXTRACTIONS = "e3_pdf_extractions",
  E3_PDF_PAGE_SELECTION = "e3_pdf_page_selection",
  E3_PORTFOLIOS = "e3_portfolios",
  E3_POSITIONS = "e3_positions",
  E3_STATIC_DATA = "e3_static_data",
  E3_TIME_SERIE_FILES = "e3_time_serie_files",
  E3_TIME_SERIES = "e3_time_series",
  E3_TRANSACTIONS = "e3_transactions",
  ENUM_TRANSLATIONS = "enum_translations",
  ETF_STATIC_DATA = "etf_static_data",
  F1_ISSUERS_EXCLUSION = "f1_issuers_exclusion",
  F1_STRATEGY_METADATA = "f1_strategy_metadata",
  F1_TIME_SERIE_FILES = "f1_time_serie_files",
  FACTOR_REGRESSIONS = "factor_regressions",
  FACTORS = "factors",
  FILE_DELIVERIES = "file_deliveries",
  FINANCIAL_INDICATORS = "financial_indicators",
  FO_BANK_CONTACT = "fo_bank_contact",
  FOREIGN_EXCHANGE_RATES = "foreign_exchange_rates",
  G4_DYNAMIC_DATA = "g4_dynamic_data",
  G4_EXPORTS = "g4_exports",
  G4_METADATA = "g4_metadata",
  G4_POSITIONS = "g4_positions",
  G4_SUSTAINALYTICS_ESG = "g4_sustainalytics_esg",
  GATE_FINANCIAL_RESEARCH_EMBEDDINGS = "gate_financial_research_embeddings",
  GATE_TIME_SERIE_FILES = "gate_time_serie_files",
  GROUP_USERS = "group_users",
  GROUP_USERS_USERS = "group_users_users",
  HISTORICAL_EVENTS = "historical_events",
  I1_EXPORTS = "i1_exports",
  I1_POSITIONS = "i1_positions",
  I1_TIME_SERIE_FILES = "i1_time_serie_files",
  INPUT_FILES = "input_files",
  ISSUER_EVENTS = "issuer_events",
  ISSUER_NEWS = "issuer_news",
  ISSUERS = "issuers",
  K1_CAPITAL_ACCOUNT = "k1_capital_account",
  K1_COMMENTS = "k1_comments",
  K1_DOCUMENT_DIFFS = "k1_document_diffs",
  K1_DOCUMENTS = "k1_documents",
  K1_EMAIL_LOGS = "k1_email_logs",
  K1_FUND_COMPOSITIONS = "k1_fund_compositions",
  K1_FUNDS = "k1_funds",
  K1_FUNDS_PORTFOLIO = "k1_funds_portfolio",
  K1_ISSUERS = "k1_issuers",
  K1_MANAGEMENT_COMPANIES = "k1_management_companies",
  K1_PE_FUNDS = "k1_pe_funds",
  K1_PORTFOLIO_COMPANIES = "k1_portfolio_companies",
  K1_PORTFOLIOS = "k1_portfolios",
  K1_POSITIONS = "k1_positions",
  K1_RAW_CAPITAL_ACCOUNT = "k1_raw_capital_account",
  K1_RAW_FUND_OVERVIEW = "k1_raw_fund_overview",
  K1_RAW_GENERAL_INFORMATION = "k1_raw_general_information",
  K1_RAW_PORTFOLIO_POSITIONS = "k1_raw_portfolio_positions",
  K1_RECONCILIATION_CONTROLS = "k1_reconciliation_controls",
  K1_TIME_SERIE_FILES = "k1_time_serie_files",
  K1_TIME_SERIES = "k1_time_series",
  K1_TRANSACTIONS = "k1_transactions",
  K2_ISSUERS = "k2_issuers",
  K2_PDF_EXPORTS = "k2_pdf_exports",
  K2_PDF_PAGE_SELECTION = "k2_pdf_page_selection",
  K2_PORTFOLIOS = "k2_portfolios",
  K2_STATIC_DATA = "k2_static_data",
  K2_TIME_SERIE_FILES = "k2_time_serie_files",
  K2_TIME_SERIES = "k2_time_series",
  K2_TRANSACTIONS = "k2_transactions",
  L1_BANK_POSITIONS = "l1_bank_positions",
  L1_COMPOSITIONS = "l1_compositions",
  L1_DERIVATIVE_BARRIERS = "l1_derivative_barriers",
  L1_DERIVATIVE_UNDERLYINGS = "l1_derivative_underlyings",
  L1_ISSUERS = "l1_issuers",
  L1_MASKING = "l1_masking",
  L1_PORTFOLIOS = "l1_portfolios",
  L1_POSITIONS = "l1_positions",
  L1_STATIC_DATA = "l1_static_data",
  L1_EVENTS = "l1_events",
  L1_TIME_SERIE_FILES = "l1_time_serie_files",
  L1_TIME_SERIES = "l1_time_series",
  L1_TRANSACTIONS = "l1_transactions",
  LINKS = "links",
  M2_ISSUERS = "m2_issuers",
  M2_POSITIONS = "m2_positions",
  M2_STATIC_DATA = "m2_static_data",
  M2_TIME_SERIE_FILES = "m2_time_serie_files",
  MACRO_KEYWORDS = "macro_keywords",
  MEMBERSHIPS = "memberships",
  MESSAGES = "messages",
  N1_BANK_POSITIONS = "n1_bank_positions",
  N1_ISSUERS = "n1_issuers",
  N1_MASKING = "n1_masking",
  N1_METADATA = "n1_metadata",
  N1_PLANS = "n1_plans",
  N1_PORTFOLIOS = "n1_portfolios",
  N1_POSITIONS = "n1_positions",
  N1_STATIC_DATA = "n1_static_data",
  N1_EVENTS = "n1_events",
  N1_STRATEGY_METADATA = "n1_strategy_metadata",
  N1_TIME_SERIE_FILES = "n1_time_serie_files",
  N1_TIME_SERIES = "n1_time_series",
  N1_TRANSACTIONS = "n1_transactions",
  OLD_PASSWORDS = "old_passwords",
  OPEN_FIGIS = "open_figis",
  OWLSHARE_TIME_SERIES = "owlshare_time_series",
  PERMISSIONS = "permissions",
  POLICIES = "policies",
  PRINCIPAL_COMPONENTS = "principal_components",
  PROFILES = "profiles",
  PROFILES_STRATEGIES = "profiles_strategies",
  PROVIDER_CONFIG_PERMISSIONS = "provider_config_permissions",
  PROVIDER_CONFIGS = "provider_configs",
  RATING_CONVERSIONS = "rating_conversions",
  REGRESSIONS = "regressions",
  REPORTS = "reports",
  RISK_INDICATOR_MATRICES = "risk_indicator_matrices",
  S1_BANK_POSITIONS = "s1_bank_positions",
  S1_EXPORTS = "s1_exports",
  S1_INVEST_STRATEGIES = "s1_invest_strategies",
  S1_ISSUERS = "s1_issuers",
  S1_METADATA = "s1_metadata",
  S1_MONTHLY_COMMENTS = "s1_monthly_comments",
  S1_PDF_EXPORTS = "s1_pdf_exports",
  S1_PDF_PAGE_SELECTION = "s1_pdf_page_selection",
  S1_PORTFOLIOS = "s1_portfolios",
  S1_POSITIONS = "s1_positions",
  S1_STATIC_DATA = "s1_static_data",
  S1_TIME_SERIE_FILES = "s1_time_serie_files",
  S1_TIME_SERIES = "s1_time_series",
  S1_TRANSACTIONS = "s1_transactions",
  S2_CAPITAL_ACCOUNT = "s2_capital_account",
  S2_CAPITAL_ACCOUNT_COMPARE = "s2_capital_account_compare",
  S2_DOCUMENTS = "s2_documents",
  S2_FUND_OVERVIEW = "s2_fund_overview",
  S2_PORTFOLIO_GENERAL_INFORMATION = "s2_portfolio_general_information",
  S2_PORTFOLIO_POSITIONS = "s2_portfolio_positions",
  S2_TIME_SERIE_FILES = "s2_time_serie_files",
  S3_BANK_POSITIONS = "s3_bank_positions",
  S3_ISSUERS = "s3_issuers",
  S3_PDF_EXPORTS = "s3_pdf_exports",
  S3_PDF_PAGE_SELECTION = "s3_pdf_page_selection",
  S3_PORTFOLIOS = "s3_portfolios",
  S3_POSITIONS = "s3_positions",
  S3_STATIC_DATA = "s3_static_data",
  S3_EVENTS = "s3_events",
  S3_TIME_SERIE_FILES = "s3_time_serie_files",
  S3_TIME_SERIES = "s3_time_series",
  S3_TRANSACTIONS = "s3_transactions",
  SCHEMA_MIGRATIONS = "schema_migrations",
  SCR_DYNAMIC_DATA = "scr_dynamic_data",
  SPT_REQUESTS = "spt_requests",
  STOCK_EXCHANGES = "stock_exchanges",
  STRATEGIES = "strategies",
  STRATEGY_AXIS_KEYWORDS = "strategy_axis_keywords",
  STRATEGY_CHILDREN = "strategy_children",
  STRATEGY_COMMENTS = "strategy_comments",
  STRATEGY_COMPOSITION_DATES = "strategy_composition_dates",
  STRATEGY_CONSTITUENTS = "strategy_constituents",
  STRATEGY_CUSTOM_DATA = "strategy_custom_data",
  STRATEGY_FACTORS = "strategy_factors",
  STRATEGY_VERSIONS = "strategy_versions",
  TAGGINGS = "taggings",
  TAGS = "tags",
  TIME_SERIE_FILE_DATES = "time_serie_file_dates",
  TIME_SERIE_FILES = "time_serie_files",
  TIME_SERIES = "time_series",
  TPT_STATIC_DATA = "tpt_static_data",
  TRANSACTIONS = "transactions",
  URGEWALDS = "urgewalds",
  USER_SESSIONS = "user_sessions",
  USERS = "users",
  VALQUANT_MATRIX_TIME_SERIES = "valquant_matrix_time_series",
  VERSIONS = "versions",
  VIEWS = "views",
  VIGEO_TIME_SERIES = "vigeo_time_series",
  VISITS = "visits",
  WORKBOOKS = "workbooks",
}
